export enum StorageKeys {
	passProof = '@theyxolo/pass-proof',
	passProofMessage = '@theyxolo/pass-proof--message',

	theme = '@theyxolo/theme',
	cookieConsent = '@theyxolo/cookie-consent',

	i18nLng = 'i18nextLng',
}
